import { isTourActive } from './constants';

// Client-side filtering for the Setup → Tours table. The Setup page already
// holds every tour the company owns (no server paging), so a company with
// hundreds of tours can be searched in memory.

export const EMPTY_TOUR_FILTERS = { search: '', status: '', city: '' };

// Lowercase and strip accents, so "cordoba" finds "Córdoba".
export const normaliseForSearch = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

export const hasActiveTourFilters = filters =>
  Boolean(normaliseForSearch(filters.search) || filters.status || filters.city);

// Distinct cities, compared case-insensitively (tour.city is free text and
// arrives in mixed case), labelled the way the City column shows them.
export const tourCityOptions = tours => {
  const byKey = new Map();
  (tours || []).forEach(tour => {
    const key = normaliseForSearch(tour.city);
    if (key && !byKey.has(key)) {
      const city = String(tour.city).trim();
      byKey.set(key, city.charAt(0).toUpperCase() + city.slice(1));
    }
  });
  return [...byKey.entries()]
    .map(([value, label]) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

// Every search word must appear in the title or the city, in any order, so
// "walking rome" finds "Rome Old Town Walking Tour".
export const filterTours = (tours, filters) => {
  const words = normaliseForSearch(filters.search)
    .split(/\s+/)
    .filter(Boolean);

  return (tours || []).filter(tour => {
    if (filters.status === 'active' && !isTourActive(tour)) return false;
    if (filters.status === 'incomplete' && isTourActive(tour)) return false;
    if (filters.city && normaliseForSearch(tour.city) !== filters.city) return false;
    if (!words.length) return true;
    const haystack = `${normaliseForSearch(tour.title)} ${normaliseForSearch(tour.city)}`;
    return words.every(word => haystack.includes(word));
  });
};
